import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, FormControl, Select, MenuItem } from "@material-ui/core";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { FileInput, Checkboxes } from "../../../FlowConfigurationInputs";

export default function Copy({ action, variables, setOpenVariable }) {
  const [sizeType, setSizeType] = useState("");
  const [checked, setChecked] = useState(false);
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FILE.";
  const options = {
    fileInput: {
      checkExtension: (ext) => {
        return true;
      },
      fileType:
        "",
    },
    checkboxes: { label: label + "OVERWRITE" },
  };


  // copy action is control default value and isRequeid area  
  useEffect(() => {
    if (!action.fields.sizeType) {
      action.fields.sizeType = { value: "" };
    } else {
      if (action.fields.sizeType.value.length > 0) {
        setChecked(true);
      }
      setSizeType(action.fields.sizeType.value);
    }
    if (!action.fields.size?.value) {
      action.fields.size = { value: "" };
    }
  }, [action, variables]);

  // set selected size type
  function handleSizeTypeChange(e) {
    setSizeType(e.target.value);
    action.fields.sizeType.value = e.target.value;
  }

  function handleChange(event) {
    setChecked(!checked);
    if (!event.target.checked) {
      action.fields.sizeType.value = "";
      action.fields.size.value = "";
      action.fields.size.htmlValue = "";
      action.fields.size.isRequired = false;
    } else {
      action.fields.size.isRequired = true;
    }
  }

  return (
    <div>
      <div className="form-element">
        {t(label + "SOURCEFILE")}
        <FileInput
          action={action}
          inputName="sourceFile"
          options={options.fileInput}
          isRequired={true}
          isSize={true}
        />
      </div>
      <div className="form-element">
        {t(label + "DESTINATION")}
        <TextInput
          action={action}
          inputName="destinationFile"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          fieldType="string"
          displayName={t(label + 'DESTINATION')}
        />
      </div>
      <div className="form-element">
        <Checkboxes
          action={action}
          inputName="overwriteFile"
          options={options.checkboxes}
        />
      </div>
      <div className="form-element">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              name="size"
              color="#C4C4C4"
              size="small"
            />
          }
          label={t(label + "SIZE")}
        />
        <div>
          <div className="form-element">
            <FormControl variant="outlined" disabled={!checked} fullWidth style={{ width: "90%" }}>
              <Select value={sizeType} onChange={handleSizeTypeChange}>
                <MenuItem value="atleast">{t(label + "ATLEAST")}</MenuItem>
                <MenuItem value="atmost">{t(label + "ATMOST")}</MenuItem>
                <MenuItem value="exact">{t(label + "EXACT")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div
            className="form-element"
            style={{ pointerEvents: !checked && "none" }}
          >
            <span style={{ color: !checked && 'var(--manatee)' }}>{t(label + "SIZE")}(KB) </span>
            <TextInput
              action={action}
              inputName="size"
              variables={variables}
              setOpenVariable={setOpenVariable}
              isRequired={checked}
              fieldType="number"
              displayName={t(label + 'SIZE')}
            />
          </div>
        </div>
      </div>
    </div>
  );
}